import React from 'react'
import {
  Box,
  Grid,
  Button,
  TextField,
  InputAdornment,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import GetAppIcon from '@mui/icons-material/GetApp'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { commonStyles, layoutStyles } from '../styles'

const NotificationFilters = ({
  searchName,
  onSearchChange,
  selectedStatus,
  onStatusChange,
  selectedSeverity,
  onSeverityChange,
  selectedType,
  onTypeChange,
  fromDate,
  onFromDateChange,
  toDate,
  onToDateChange,
  onExport,
  headerRef,
}) => {
  return (
    <Box ref={headerRef} sx={layoutStyles.header}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <div style={layoutStyles.searchContainer}>
            <div style={layoutStyles.searchWrapper}>
              <TextField
                placeholder="Search by plant name, type, or message..."
                variant="outlined"
                size="small"
                onChange={onSearchChange}
                value={searchName}
                sx={commonStyles.searchInput}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <SearchIcon style={{ color: '#5968b7' }} />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
          </div>
        </Grid>

        <Grid item xs={12} md={6}>
          <div style={layoutStyles.filtersContainer}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <div style={layoutStyles.datePickerWrapper}>
                <DatePicker
                  label="From Date"
                  format="DD-MM-YYYY"
                  value={fromDate}
                  onChange={onFromDateChange}
                  slotProps={{
                    textField: {
                      size: 'small',
                      sx: commonStyles.datePicker,
                    },
                  }}
                />
              </div>
            </LocalizationProvider>

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <div style={layoutStyles.datePickerWrapper}>
                <DatePicker
                  label="To Date"
                  format="DD-MM-YYYY"
                  value={toDate}
                  onChange={onToDateChange}
                  slotProps={{
                    textField: {
                      size: 'small',
                      sx: commonStyles.datePicker,
                    },
                  }}
                />
              </div>
            </LocalizationProvider>

            <FormControl sx={{ minWidth: 120 }} size="small">
              <InputLabel>Status</InputLabel>
              <Select
                value={selectedStatus}
                onChange={onStatusChange}
                label="Status"
                sx={commonStyles.selectDropdown}
              >
                <MenuItem value="">All</MenuItem>
                <MenuItem value="unread">Unread</MenuItem>
                <MenuItem value="resolved">Resolved</MenuItem>
                <MenuItem value="read">Read</MenuItem>
              </Select>
            </FormControl>

            <FormControl sx={{ minWidth: 120 }} size="small">
              <InputLabel>Severity</InputLabel>
              <Select
                value={selectedSeverity}
                onChange={onSeverityChange}
                label="Severity"
                sx={commonStyles.selectDropdown}
              >
                <MenuItem value="">All</MenuItem>
                <MenuItem value="critical">Critical</MenuItem>
                <MenuItem value="high">High</MenuItem>
                <MenuItem value="medium">Medium</MenuItem>
                <MenuItem value="low">Low</MenuItem>
              </Select>
            </FormControl>

            <FormControl sx={{ minWidth: 140 }} size="small">
              <InputLabel>Type</InputLabel>
              <Select
                value={selectedType}
                onChange={onTypeChange}
                label="Type"
                sx={commonStyles.selectDropdown}
              >
                <MenuItem value="">All</MenuItem>
                <MenuItem value="COMMUNICATION_ERROR">COMMUNICATION_ERROR</MenuItem>
                <MenuItem value="GENERATION_DATA_ERROR">
                  GENERATION_DATA_ERROR
                </MenuItem>
                <MenuItem value="GENERATION_LOSS">GENERATION_LOSS</MenuItem>
              </Select>
            </FormControl>

            <Button
              onClick={onExport}
              startIcon={<GetAppIcon />}
              sx={commonStyles.primaryButton}
            >
              Export CSV
            </Button>
          </div>
        </Grid>
      </Grid>
    </Box>
  )
}

export default NotificationFilters
